import { useTranslation } from "react-i18next";
import { useAreaCrumbs } from "@/components/areaCrumbs";
import { PageBreadcrumbs } from "@/components/PageBreadcrumbs";
import { Text } from "@/components/Text";
import { useAdminCanEdit } from "../useAdminCanEdit";
import { NewModelForm } from "./NewModelForm";

/** /admin/models/new: a full page, not a modal (docs/design/web/WEB_ADMIN_DESIGN.md decision 4). */
export function NewModelPage() {
  const { t } = useTranslation("adminModels");
  const { t: tAdmin } = useTranslation("admin");
  const areas = useAreaCrumbs();
  const canEdit = useAdminCanEdit();
  return (
    <div className="flex flex-col">
      <PageBreadcrumbs trail={[areas.admin, { label: t("title"), to: "/admin/models" }]} current={t("add")} />
      <div className="mx-auto flex w-full max-w-3xl flex-col gap-6 px-4 py-6 md:px-8">
        {canEdit ? <NewModelForm /> : <Text tone="secondary">{tAdmin("readOnlyMobile")}</Text>}
      </div>
    </div>
  );
}
